import React, { Component } from 'react';
import { DatePicker } from 'antd';
import { FORMAT_DEFAULT_MONTH } from '../../utils/dates';
import ComponentWrapper from './ComponentWrapper';
import { monthYearMap } from './componentMappers';

const { MonthPicker } = DatePicker;

export default class MonthYearField extends Component {
  render() {
    return (
      <ComponentWrapper
        {...this.props}
        mapProps={monthYearMap}
        render={(props) => {
          // Extract onBlur/onFocus so they are only triggered via onOpenChange
          // (when the picker truly opens/closes), not via native input focus events.
          // Without this, clicking the calendar panel blurs the input, causing
          // react-final-form to mark the field as inactive while still picking a date.
          const { onBlur, onFocus, ...restProps } = props;
          return (
            <MonthPicker
              {...restProps}
              format={FORMAT_DEFAULT_MONTH}
              onOpenChange={(status) => {
                status ? onFocus?.() : onBlur?.();
              }}
            />
          );
        }}
      />
    );
  }
}
